import { t } from '../languages';
import mitt from 'mitt';
const emitter = mitt();
export default emitter;
